import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../config';

const hrBackofficeService = {
  // Get dashboard statistics
  getDashboardStats: async (period = '30d', options = {}) => {
    try {
      const { startDate, endDate } = options;
      let queryParams = `?period=${period}`;
      if (startDate) queryParams += `&startDate=${startDate}`;
      if (endDate) queryParams += `&endDate=${endDate}`;

      const response = await apiClient.get(`${API_ENDPOINTS.HR_BACKOFFICE.DASHBOARD_STATS}${queryParams}`);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get recent activities
  getRecentActivities: async (limit = 10) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.HR_BACKOFFICE.RECENT_ACTIVITIES}?limit=${limit}`);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get pending tasks
  getPendingTasks: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.HR_BACKOFFICE.PENDING_TASKS);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get quick statistics
  getQuickStats: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.HR_BACKOFFICE.QUICK_STATS);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  }
};

export default hrBackofficeService;
